export default __webpack_public_path__ + "static/media/OLIVE.535e2a74.png";